import {computed, ref} from 'vue'
import {defineStore} from 'pinia'

export type DeviceState = 'notAvailable' | 'on' | 'muted'

// Same transitions as the former `app.camera` / `app.microphone` machine states:
// notAvailable -> (available) -> on <-> muted, (notAvailable) from any available state
export const createDeviceStore = (id: 'camera' | 'microphone') =>
  defineStore(id, () => {
    const state = ref<DeviceState>('notAvailable')

    const isAvailable = computed(() => state.value !== 'notAvailable')
    const isNotAvailable = computed(() => state.value === 'notAvailable')
    const isOn = computed(() => state.value === 'on')
    const isMuted = computed(() => state.value === 'muted')

    function setAvailable() {
      if (state.value === 'notAvailable') state.value = 'on'
    }

    function setNotAvailable() {
      state.value = 'notAvailable'
    }

    function mute() {
      if (state.value === 'on') state.value = 'muted'
    }

    function unmute() {
      if (state.value === 'muted') state.value = 'on'
    }

    return {state, isAvailable, isNotAvailable, isOn, isMuted, setAvailable, setNotAvailable, mute, unmute}
  })
